import React, {useEffect, useState} from "react";
import {Card, CardContent, Typography, Grid} from "@mui/material";
import useDashboard from "../../../hooks/useDashboard";
import moment from "moment";
import Tooltip, {tooltipClasses} from "@mui/material/Tooltip";
import {styled} from "@mui/system";

const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{popper: className}} />

    ))(({theme}) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: "#fff",
            color: "rgba(51, 51, 207, 0.808)",
            boxShadow: "0px 5px 5px -3px rgb(0 0 0 / 10%), 0px 8px 10px 1px rgb(0 0 0 / 4%), 0px 3px 14px 2px rgba(0,0,0,0.12)",
            fontSize: 13,
            padding: theme.spacing(2),
            borderRadius: theme.shape.borderRadius, 
        },
  
        "& .MuiTooltip-arrow": {
            color: "#fff", 

            "&:before": {
                //
            }
        }
    })
);

const AuthenticationMetricsComponent = (props) => {
    const {breakpoints, authenticationOverviewCount} = props;

    const {getTotalAuthenticationPerHour, totalAuthenticationPerHour} = useDashboard();

    const [authenticationMetrics, setAuthenticationMetrics] = useState(null);
    const [totalAuthenticationPerHourData, setTotalAuthenticationPerHourData] = useState(0);

    const startDate = moment().format("YYYY-MM-DD HH:00");
    const endDate = moment().add(1, "hour").format("YYYY-MM-DD HH:00");

    
    useEffect(() => {
        if (authenticationOverviewCount) {
            const calculateAuthenticationMetrics = (authenticationOverviewCount) => {
                let completedCount = 0;
                let errorCount = 0;
                let pendingCount = 0;
            
                authenticationOverviewCount?.product?.forEach(item => {
                    if (item.Completed) completedCount += item.Completed;
                    if (item.Error) errorCount += item.Error;
                    if (item.Pending) pendingCount += item.Pending;
                })
            
     
                authenticationOverviewCount?.document?.forEach(item => {
                    if (item.Completed) completedCount += item.Completed;
                    if (item.Error) errorCount += item.Error;
                    if (item.Pending) pendingCount += item.Pending;
                })
            
                return {
                    completed: completedCount,
                    error: errorCount,
                    pending: pendingCount
                }
            }

            setAuthenticationMetrics(calculateAuthenticationMetrics(authenticationOverviewCount));
        }
    }, [authenticationOverviewCount])

    useEffect(() => {
        getTotalAuthenticationPerHour(startDate, endDate);
    }, [startDate, endDate])

    useEffect(() => {
        if (totalAuthenticationPerHour) {
            const productCount = totalAuthenticationPerHour?.product?.length > 0 ? totalAuthenticationPerHour.product[0].count : 0;
            const documentCount = totalAuthenticationPerHour?.document?.length > 0 ? totalAuthenticationPerHour.document[0].count : 0;
            
            const totalCount = productCount + documentCount;
            setTotalAuthenticationPerHourData(totalCount);
        }
    }, [totalAuthenticationPerHour])


    return (
        <Grid container spacing={1.5}>
            <Grid item xs={12} sm={3}>
                <LightTooltip title="Total number of successful authentications" arrow placement="top"> 
                    <Card variant="outlined" sx={{backgroundColor: "#40BF7E1A", border: "0.1px solid #40BF7E", borderRadius: "8px"}}>
                        <CardContent sx={{pb: "16px !important"}}>
                            <Typography variant="body2" sx={{fontSize: "15px", color: "#58565f"}}>
                                Total Successful Authentications
                            </Typography>

                            <Typography variant="body2" sx={{fontSize: "16px", color: "#40BF7E", fontWeight: "bold", mt: "5px"}}>
                                {authenticationMetrics?.completed}                      
                            </Typography>
                        </CardContent>
                    </Card>
                </LightTooltip>
            </Grid>

            <Grid item xs={12} sm={3}>
                <LightTooltip title="Total number of pending authentications" arrow placement="top"> 
                    <Card variant="outlined" sx={{backgroundColor: "#FFA50014", border: "0.1px solid #FFA500", borderRadius: "8px"}}>
                        <CardContent sx={{pb: "16px !important"}}>
                            <Typography variant="body2" sx={{fontSize: "15px", color: "#58565f"}}>
                                Total Pending Authentications
                            </Typography>

                            <Typography variant="body2" sx={{fontSize: "16px", color: "#FFA500", fontWeight: "bold", mt: "5px"}}>
                                {authenticationMetrics?.pending}                      
                            </Typography>
                        </CardContent>
                    </Card>
                </LightTooltip>
            </Grid>

            <Grid item xs={12} sm={3}>
                <LightTooltip title="Total number of failed authentications" arrow placement="top"> 
                    <Card variant="outlined" sx={{backgroundColor: "#E76C5920", border: "0.1px solid #E76C59", borderRadius: "8px"}}>
                        <CardContent sx={{pb: "16px !important"}}>
                            <Typography variant="body2" sx={{fontSize: "15px", color: "#58565f"}}>
                                Total Failed Authentications
                            </Typography>

                            <Typography variant="body2" sx={{fontSize: "16px", color: "#E76C59", fontWeight: "bold", mt: "5px"}}>
                                {authenticationMetrics?.error}                      
                            </Typography>
                        </CardContent>
                    </Card>
                </LightTooltip>
            </Grid>

            <Grid item xs={12} sm={3}>
                <LightTooltip title="Total authentications completed in the current hour" arrow placement="top"> 
                    <Card variant="outlined" sx={{backgroundColor: "#3333CF14", border: "0.1px solid #3333CF", borderRadius: "8px"}}>
                        <CardContent sx={{pb: "16px !important"}}>
                            <Typography variant="body2" sx={{fontSize: "15px", color: "#58565f"}}>
                                Total Authentications in this hour  
                            </Typography>

                            <Typography variant="body2" sx={{fontSize: "16px", color: "#3333CF", fontWeight: "bold", mt: "5px"}}>
                                {totalAuthenticationPerHourData}                      
                            </Typography>
                        </CardContent>
                    </Card>
                </LightTooltip>
            </Grid>
        </Grid>
    )
}

export default AuthenticationMetricsComponent